export default __webpack_public_path__ + "static/media/RahulBhardwaj_COO_JungleeGames.866de611.jpg";